import { BaseContainer } from './BaseContainer';
import { MarketingEventsIcon } from 'foundations-assets/icons/components/MarketingEventsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingEventSvg = () => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: '60%',
    children: /*#__PURE__*/_jsx(MarketingEventsIcon, {})
  });
};